var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.data),expression:"data"}],staticClass:"mt-2",attrs:{"loading":_vm.isLoading,"title":"Export to Excel","icon":"","small":""},on:{"click":_vm.exportToExcel}},'v-btn',_vm.$props,false),_vm.$listeners),[_c('v-icon',[_vm._v(_vm._s(_vm.mdiFileExcel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }